import { scrollToFeedbackMessage } from '@modules/feedback/components/AudioType/utils';
import { PLAYING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME } from '../AudioTranscript/constants';

const SCROLL_BUFFER = 200;

export const scrollToPlayingAudioTranscriptMessageIfRequired = (
  msgIndex: number,
) => {
  const audioTranscriptContainer = document.querySelector(
    '.audio-transcript-popper-js',
  );
  const messageToHighlight = document.querySelector(
    `#expanded-feedback-container [data-audio-message-id="${msgIndex.toString()}"]`,
  );

  if (!audioTranscriptContainer || !messageToHighlight) {
    return;
  }

  const audioTranscriptContainerRect =
    audioTranscriptContainer.getBoundingClientRect();

  const messageToHighlightRect = messageToHighlight.getBoundingClientRect();

  const isHighlightedMessageAboveViewport =
    audioTranscriptContainerRect.top > messageToHighlightRect.bottom;

  const isHighlightedMessageBelowViewport =
    messageToHighlightRect.top + SCROLL_BUFFER >
    audioTranscriptContainerRect.bottom;

  const isAlreadyFeedbackPlaying = messageToHighlight.classList.contains(
    PLAYING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME,
  );

  // If the user has explicitly scrolled down in view; we don't force them
  // back up to current playing message
  if (isHighlightedMessageAboveViewport) {
    return;
  }

  // If the user has explicitly scrolled up in view; we force them back
  // down to current playing message
  if (isHighlightedMessageBelowViewport) {
    scrollToFeedbackMessage({
      scrollElID: msgIndex.toString(),
      dataAttribute: 'data-audio-message-id',
    });
    return;
  }

  // If we have already scrolled to that feedback message; we don't scroll
  // to that message
  if (isAlreadyFeedbackPlaying) {
    return;
  }

  scrollToFeedbackMessage({
    scrollElID: msgIndex.toString(),
    dataAttribute: 'data-audio-message-id',
  });
};
